const HeroSection = ({ scrollToPaket }) => {
  return (
    <section className="relative overflow-hidden min-h-screen flex items-center">
      {/* Video Background */}
     <div className="absolute inset-0 z-0">
        <video
          width="100%"
          height="100%"
          autoplay
          loop
          muted
          controls
          className="w-full h-full object-cover"
        >
          <source src="/image/IPTV.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        {/* Video Overlay */}
        <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-blue-900/60 to-black/80"></div>
        <div className="absolute inset-0 bg-black/50"></div>
      </div>


      {/* Content */}
      <div className="relative z-20 max-w-7xl mx-auto px-4 text-center w-full">
        <div className="mb-8">
          <h1 className="text-5xl md:text-7xl font-bold mb-6 leading-tight">
            TV & <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#1E9B4C]">IPTV</span> Terbaik
          </h1>
          <p className="text-xl md:text-2xl mb-8 text-[#dfe4e0ff] max-w-4xl mx-auto leading-relaxed">
            Nikmati ribuan saluran TV HD, konten premium, dan streaming berkualitas 4K dengan teknologi IPTV terdepan. Hiburan tanpa batas untuk seluruh keluarga.
          </p>
        </div>

        {/* CTA Buttons */}
        {/* <div className="flex flex-col sm:flex-row gap-4 justify-center mb-16">
          <button
            onClick={scrollToPaket}  // Call the scrollToPaket function here
            className="bg-white text-[#1E9B4C] px-8 py-4 rounded-full font-bold text-lg hover:bg-gray-100 transition-all transform hover:scale-105 pulse-animation shadow-2xl"
          >
            Langganan Sekarang
          </button>
        </div> */}
      </div>
    </section>
  );
};

export default HeroSection;